import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { MODIS } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import format from 'date-fns/format'

export class Modis extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions } = this.props
    const id = 'Modis'
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { layerRendered, paint, time } = this.props

    const visible = layerRendered
    const before = 'default'
    const timeIso = time ? new Date(time).toISOString() : ''
    const rasterSource = {
      type: 'raster',
      tiles: [MODIS({ timeIso })],
      tileSize: 256,
      maxzoom: 9
    }

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source id='Modis' tileJsonSource={rasterSource} />
        <Layer
          type='raster'
          id='Modis'
          sourceId='Modis'
          layout={{ visibility: visible ? 'visible' : 'none' }}
          paint={paint}
          before={before}
        />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()

  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(state, 'ModisIceDrift', 'default'),
      paint: getPaint(state, 'Modis'),
      time: state.layer.times['ModisIceDrift'] || undefined
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps(), null)(Modis)



// WEBPACK FOOTER //
// ./src/layers/ModisIceDrift.js